import React from 'react';
import DSBox from '../../../design-system/DSBox';
import DSTypography from '../../../design-system/Typography/DSTypography';
import { useTheme } from '@mui/material';
import HelpFAQ from './HelpFAQ';
import GuidesSection from './GuidesSection';
import DownloadsSection from './DownloadsSection';
import DSCollapsibleSection from '../../../design-system/DSCollapsibleSection';
import { HELP_ALERT } from '../../../consts/alerts';
import useContactSupport from '../../../hooks/useContactSupport';
import DSTabGradientViewPaper from '../../../design-system/Paper/DSTabGradientViewPaper';

const Help = () => {
  const { spacing, palette } = useTheme();
  const { openSupport, supportEmail } = useContactSupport();

  return (
    <DSTabGradientViewPaper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        paddingX: { xxs: '2%', lg: '3.3%' },
        paddingY: '2%',
        overflowY: 'auto',
        height: '90%',
        gap: spacing(4),
      }}
    >
      <GuidesSection />

      <DownloadsSection />

      <DSCollapsibleSection title="FAQs">
        <DSBox sx={{ padding: spacing(2) }}>
          <HelpFAQ />
        </DSBox>
      </DSCollapsibleSection>

      <DSBox
        sx={{
          textAlign: 'center',
          paddingBottom: spacing(2),
        }}
      >
        <DSTypography variant="body1" sx={{ marginBottom: spacing(1) }}>
          {HELP_ALERT}
        </DSTypography>
        <DSTypography
          variant="body1"
          sx={{
            textDecoration: 'underline',
            color: palette.text.primary,
            cursor: 'pointer',
            '&:hover': {
              color: palette.primary.main,
            },
          }}
          onClick={openSupport}
        >
          {supportEmail}
        </DSTypography>
      </DSBox>
    </DSTabGradientViewPaper>
  );
};

export default Help;
